<template>
    <div class="settings-block">
        <div class="block-header">
            <h3>{{ $t('Управленние данными') }}</h3>
        </div>
        <div class="block-content">
            <div class="col-12">
                <p class="mt-0">
                    {{ $t('data_clear_description') }}
                </p>
                <button @click="openClearData" class="btn btn-blue mb-10">{{ $t('Очистить данные') }}</button>
                <p class="mt-5">
                    {{ $t('profile_delete_description') }}
                </p>
                <button @click="openDeleteAccount" class="btn btn-red">{{ $t('Удалить профиль') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { EventBus } from '../../../event-bus.js';

export default {
    name: "DataManager",

    data: function() {
        return {
            errors: [],
        };
    },

    mounted() {
        //
    },

    computed: {
        ...mapState(['user']),
    },

    methods: {
        openClearData() {
            EventBus.$emit('open-side-form', 'clear-data');
        },

        openDeleteAccount() {
            EventBus.$emit('open-side-form', 'delete-account');
        },
    },
};
</script>